
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Dongia=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Dongia Picnic Spot</h1>
           <p className="sub-heading">Near Rihand Dam, a serene ecotourism retreat in Sonbhadra, offering boating and lush greenery</p>
         </div>
         <div className="description">
         Dongia Reservoir, nestled in the picturesque Pipri area of Sonbhadra, Uttar Pradesh, is a budding ecotourism destination perfect for nature enthusiasts and adventure seekers alike. Surrounded by verdant landscapes, mountains, and dense forests, this serene spot offers breathtaking views and a chance to connect with nature.

The Uttar Pradesh government has invested ₹4.14 crore to develop the reservoir into a world-class tourist hub, complete with well-maintained ghats and modern facilities. Located just 80 km from Varanasi, Dongia attracts around 300 tourists daily, including international visitors, with its peaceful ambiance and exciting boating experiences.

Whether you're looking for a relaxing picnic spot, a scenic escape, or a gateway to explore Sonbhadra’s natural beauty, Dongia Reservoir promises an unforgettable experience for all.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dongia Picnic SPot/1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dongia Picnic SPot/2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dongia Picnic SPot/3.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dongia Picnic SPot/4.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dongia Picnic SPot/5.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Dongia Picnic SPot/6.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
          
         </div>
   
         <BookSection />
       </div>
     );
};